declare namespace $ {

	type $mol_view__sub_bog_blitz_lobby_join_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_join_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open_native__files_bog_blitz_lobby_join_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_join['avatar_files'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_bog_blitz_lobby_join_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_bog_blitz_lobby_join_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	type $mol_button_open__sub_bog_blitz_lobby_join_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	type $mol_string_button__hint_bog_blitz_lobby_join_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_lobby_join_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_join['player_name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_button_major__title_bog_blitz_lobby_join_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_join['join_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_lobby_join_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_join['join'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_avatar__id_bog_blitz_lobby_join_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_join['player_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_image__uri_bog_blitz_lobby_join_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_join['avatar_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	export class $bog_blitz_lobby_join extends $mol_page {
		player_id( ): string
		avatar_uri( ): string
		avatar_preview( ): any
		Avatar_circle( ): $mol_view
		Avatar_label( ): $mol_paragraph
		avatar_files( next?: readonly(File)[] ): readonly(File)[]
		Avatar_native( ): $mol_button_open_native
		Avatar( ): $mol_button_open
		player_name( next?: string ): string
		Player_name_input( ): $mol_string_button
		join( next?: any ): any
		Join( ): $mol_button_major
		Head( ): any
		is_synced( ): boolean
		profile_avatar_uri( ): string
		profile_name( ): string
		syncing_title( ): string
		join_title( ): string
		enter_title( ): string
		Avatar_icon( ): $mol_avatar
		Avatar_image( ): $mol_image
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=join.view.tree.d.ts.map